{
  "feedbackTextInputLabel": "Condividi i tuoi pensieri",
  "feedbackTextInputPlaceholder": "Vorrei condividere un po' di feedback...",
  "likeOrDislikeWithFeatureName": "Ti piace {{featureName}}?",
  "linkTo": "Condividi feedback",
  "other": "Qualcos'altro",
  "subjectTextInputLabel": "Soggetto",
  "subjectTextInputPlaceholder": "(Scegli argomento)",
  "successMessage": "Il tuo feedback è stato ricevuto.",
  "description": "Ci piacerebbe conoscere le tue idee su come possiamo migliorare il nostro prodotto.",
  "title": "Condividi feedback"
}
